import { createFileRoute } from "@tanstack/react-router";

import { HStack } from "@/components/Layout";

import { BUSINESS_PARTNER_TYPE_STEPS } from "../-constants/steps";
import useBusinessPartnerTypeParam from "../-hooks/useBusinessPartnerType";
import { getBusinessPartnerFormStoreContext } from "../-store/businessPartnerFormStoreContext";

import InnerNavigation from "./-components/InnerNavigation";
import ManualForm from "./-components/ManualForm";
import { ProgressCard } from "./-components/ProgressCard";

export const Route = createFileRoute(
  "/_staff/business-partner/add/$businessPartnerType/",
)({
  component: () => <Form />,
});

function Form() {
  const { businessPartnerType } = useBusinessPartnerTypeParam();
  const { context } = getBusinessPartnerFormStoreContext(businessPartnerType);
  const store = context.createStore();
  const steps = BUSINESS_PARTNER_TYPE_STEPS[businessPartnerType];

  return (
    <context.Provider value={store}>
      <HStack className="w-full p-6 gap-6">
        <div className="shrink-0">
          <InnerNavigation steps={steps.map((step) => step.step)} />
        </div>
        <ManualForm className="grow min-w-[340px]" steps={steps} />
        <div className="shrink-0">
          <ProgressCard steps={steps.map((step) => step.step)} />
        </div>
      </HStack>
    </context.Provider>
  );
}
